import { useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { HolmiAppFullLogo } from './HolmiAppLogo'
import styles from '../../styles/Header.module.css'

const navItems = [
  { title: 'Főoldal', url: '/' },
  { title: 'Bemutató', url: '/Bemutato' },
  { title: 'Települések', url: '/Telepulesek' },
  { title: 'Önkormányzat', url: '/Onkormanyzat' },
  { title: 'Galéria', url: '/Galeria' },
]

export default function Header() {
  const router = useRouter()
  const [open, setOpen] = useState(false)

  return (
    <nav className={styles.nav}>
      <Link href="/" className={styles.navLogo}>
        <HolmiAppFullLogo height={32} className={styles.logoFull} priority />
      </Link>

      <div className={`${styles.navLinks} ${open ? styles.navLinksOpen : ''}`}>
        {navItems.map((item) => (
          <Link
            key={item.url}
            href={item.url}
            className={`${styles.navLink} ${router.pathname === item.url ? styles.active : ''}`}
            onClick={() => setOpen(false)}
          >
            {item.title}
          </Link>
        ))}
        <Link href="/#download" className={styles.btnPrimary} onClick={() => setOpen(false)}>
          Letöltés
        </Link>
      </div>

      <button
        className={styles.burger}
        onClick={() => setOpen(!open)}
        aria-label="Menü"
        type="button"
      >
        <span className={`${styles.burgerLine} ${open ? styles.burgerOpen1 : ''}`} />
        <span className={`${styles.burgerLine} ${open ? styles.burgerOpen2 : ''}`} />
        <span className={`${styles.burgerLine} ${open ? styles.burgerOpen3 : ''}`} />
      </button>
    </nav>
  )
}